import { render, staticRenderFns } from "./viewItemTransactions.vue?vue&type=template&id=6f9c1420&"
import script from "./viewItemTransactions.vue?vue&type=script&lang=js&"
export * from "./viewItemTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports